<template>
	<svg
		v-if="type === 'left'"
		id="Layer_2"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 20 28"
		width="20"
		height="28"
	>
		<g id="Layer_56">
			<polygon class="cls-1" points="20 28 0 14 20 0 20 28" />
		</g>
	</svg>
	<svg
		v-if="type === 'right'"
		id="Layer_2"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 20 28"
		width="20"
		height="28"
	>
		<g id="Layer_56">
			<polygon class="cls-1" points="0 28 20 14 0 0 0 28" />
		</g>
	</svg>
</template>

<script lang="ts" setup>
const { type = "left" } = defineProps<{
	type?: "left" | "right";
}>();
</script>

<style lang="scss" scoped>
.cls-1 {
	fill: #f2dcb5;
}
</style>
